import React, { useState } from 'react';
import '../agenda.css'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckDouble, faExclamationTriangle, faSave } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useAuthServices } from '../../../services/useFetch';

export const RegistraDisponibilidad = ({ executeMenu, profesionalSeleccionado }) => {

    const { requestPost } = useAuthServices();

    const getColombiaDate = () => {
        return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Bogota" }));
    };

    const formatDate = (date) => {
        if (!date) return '';
        return date.toLocaleDateString('es-CO', {
            timeZone: 'America/Bogota',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const intervalosHorarios = {
        '60min': [
            '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
            '14:00', '15:00', '16:00', '17:00', '18:00'
        ],
        '30min': [
            '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00', '10:30',
            '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
            '16:00', '16:30', '17:00', '17:30', '18:00'
        ],
        '20min': [
            '6:00', '6:20', '6:40', '7:00', '7:20', '7:40', '8:00', '8:20', '8:40',
            '9:00', '9:20', '9:40', '10:00', '10:20', '10:40', '11:00', '11:20', '11:40',
            '12:00', '12:20', '12:40', '13:00', '13:20', '13:40', '14:00', '14:20', '14:40',
            '15:00', '15:20', '15:40', '16:00', '16:20', '16:40', '17:00', '17:20', '17:40', '18:00'
        ]
    };

    const [availabilityInterval, setAvailabilityInterval] = useState('60min');
    const [availabilityDateRange, setAvailabilityDateRange] = useState([getColombiaDate(), getColombiaDate()]);
    const [availabilityStartTime, setAvailabilityStartTime] = useState('');
    const [availabilityEndTime, setAvailabilityEndTime] = useState('');

    const [modalError, setModalError] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [modalOccupied, setModalOccupied] = useState(false);

    const handleSaveAvailability = async () => {
        if (!availabilityStartTime || !availabilityEndTime) {
            setModalError(true);
            return;
        }

        const [start, end] = availabilityDateRange;
        if (!!profesionalSeleccionado) {
            const body = {
                idUsuario: profesionalSeleccionado.id,
                fechaInicio: formatDate(start),
                fechaFin: formatDate(end || start),
                horaInicio: availabilityStartTime,
                horaFin: availabilityEndTime,
                intervalo: availabilityInterval
            };

            const response = await requestPost(body, 12);
            if (!response.error) {
                const { estado } = response.data;
                if (estado) {
                    setModalSuccess(true);
                    setAvailabilityStartTime('');
                    setAvailabilityEndTime('');
                    setAvailabilityDateRange([getColombiaDate(), getColombiaDate()]);
                } else {
                    setModalError(true);
                }
            } else {
                setModalError(true);
            }
        }
    };

    const handleCloseError = () => setModalError(false);

    const handleCloseSuccess = () => {
        setModalSuccess(false);
        executeMenu({
            target: { name: 'buttom3' }
        })
    }

    const handleCloseOccupied = () => setModalOccupied(false);

    return (
        <>
            <div className=''>
                <h4 className="mb-3">Definir disponibilidad:</h4>
                <div className="my-3">
                    <p className='p-label-form'> Selecciona un <span className='p-bold'>rango de fechas</span> en el calendario y crea
                        <span className='p-bold'> bloques de horario</span> según tu disponibilidad.
                        Puedes definir horarios para varios días o establecer un <span className='p-bold'>bloque de horario específico en una fecha puntual</span>,
                        permitiendo que tus clientes agenden dentro de esos espacios. </p>
                </div>
                <div className="row m-0">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-5 p-0" >
                        <div className='div-container-calendar-element-constainer'>
                            <div className='div-container-calendar-element'>
                                <div className='div-calendar-element'>
                                    <Calendar onChange={setAvailabilityDateRange} value={availabilityDateRange} selectRange={true} minDate={new Date()} className='react-calendar' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-7 p-0" >
                        <h1 className='size-db-info-agenda-h2'>
                            Rango seleccionado: {availabilityDateRange[0] ? formatDate(availabilityDateRange[0]) : ''} - {availabilityDateRange[1] ? formatDate(availabilityDateRange[1]) : ''}
                        </h1>
                        <div className="mt-3">
                            <label className='p-label-form'>Seleccione el intervalo de tiempo:</label>
                            <select className="form-control mb-3" value={availabilityInterval} onChange={(e) => setAvailabilityInterval(e.target.value)} >
                                <option value="60min">Cada 1 hora</option>
                                <option value="30min">Cada 30 minutos</option>
                                <option value="20min">Cada 20 minutos</option>
                            </select>
                        </div>
                        <div className="mt-3">
                            <label className='p-label-form'>Hora Inicio:</label>
                            <div className="row m-0">
                                {
                                    intervalosHorarios[availabilityInterval].map((hora) => (
                                        <div className="col-4 col-sm-3 col-md-3 col-lg-3" key={`start-${hora}`}>
                                            <div className='div-header-agenda-disponble'>
                                                <div className={`div-hora-agendate-disponible ${availabilityStartTime === hora ? 'selected-time' : ''}`}
                                                    onClick={() => setAvailabilityStartTime(hora)}
                                                    style={{
                                                        backgroundColor: availabilityStartTime === hora ? 'orange' : '',
                                                        cursor: 'pointer',
                                                        color: availabilityStartTime === hora ? 'white' : '',
                                                    }}>
                                                    {hora}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="mt-3">
                            <label className='p-label-form'>Hora Fin:</label>
                            <div className="row m-0">
                                {
                                    intervalosHorarios[availabilityInterval].map((hora) => {
                                        let isDisabled = false;
                                        if (availabilityStartTime) {
                                            const [startHour, startMin] = availabilityStartTime.split(':').map(Number);
                                            const [currentHour, currentMin] = hora.split(':').map(Number);
                                            if (currentHour < startHour || (currentHour === startHour && currentMin <= startMin)) {
                                                isDisabled = true;
                                            }
                                        }

                                        return (
                                            <div className="col-4 col-sm-3 col-md-3 col-lg-3" key={`end-${hora}`}>
                                                <div className='div-header-agenda-disponble'>
                                                    <div
                                                        className={`div-hora-agendate-disponible ${availabilityEndTime === hora ? 'selected-time' : ''}`}
                                                        onClick={() => !isDisabled && setAvailabilityEndTime(hora)}
                                                        style={{
                                                            backgroundColor: isDisabled ? '#e9ecef' : (availabilityEndTime === hora ? 'orange' : ''),
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            color: isDisabled ? '#6c757d' : (availabilityEndTime === hora ? 'white' : ''),
                                                            opacity: isDisabled ? 0.6 : 1
                                                        }}>
                                                        {hora}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="div-btbn-agenda-control">
                            <div className="my-3">
                                <button className='bottom-custom-secondary' onClick={handleSaveAvailability}>
                                    <FontAwesomeIcon icon={faSave} /> Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modals */}
            <Modal isOpen={modalError} toggle={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseError}>
                    <h4>Error <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Por favor asegúrate de seleccionar una hora de inicio y fin válida, o verifica tu conexión.</p>
                </ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseError}>Aceptar</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalSuccess} toggle={handleCloseSuccess} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseSuccess}>
                    <h4>Disponibilidad Guardada <FontAwesomeIcon icon={faCheckDouble} className='icon-success' style={{ color: 'green' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>¡Excelente! La disponibilidad ha sido registrada exitosamente para el rango seleccionado.</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseSuccess}>Aceptar</Button></ModalFooter>
            </Modal>

            <Modal isOpen={modalOccupied} toggle={handleCloseOccupied} className='modal-perfil-cliente'>
                <ModalHeader toggle={handleCloseOccupied}>
                    <h4>Horarios Solapados <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' style={{ color: 'orange' }} /> </h4>
                </ModalHeader>
                <ModalBody><p>Vaya, parece que algunos de los horarios seleccionados ya tienen disponibilidad definida o citas agendadas.</p></ModalBody>
                <ModalFooter><Button variant="primary" onClick={handleCloseOccupied}>Entendido</Button></ModalFooter>
            </Modal>
        </>
    );
};
